export default {"src":"/_next/static/media/about4.1c44ae17.svg","height":246,"width":281};